<template>
  <div class="beefCont">
    <img src="../assets/imgs/99/bg.jpg" class="bg" alt="" />
    <Qrcode :pic="99" :bottom="'1.7rem'" />
    <div class="phoneCommon">
        咨询电话：<a href="tel:028-87798975" style="color:#fff">028-87798975</a>、<a href="tel:028-87797499" style="color:#fff">028-87797499</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";
.beefCont {
  width: 100vw;
  position: relative;
  .bg {
    width: 100%;
    height: 73.94rem;
    display: block;
  }
}
</style>